import type { AuthMiddlewareOpts, UrlMiddlewareOpts } from "react-relay-network-modern";
import { authMiddleware, RelayNetworkLayer, urlMiddleware } from "react-relay-network-modern";

import { invalidGatewayToken } from "./invalid-gateway-token";
import { persistedQueries } from "./persisted-queries";

export type NetworkOptions = {
  authOptions: AuthMiddlewareOpts;
  urlOptions: UrlMiddlewareOpts;
};

export const network = ({ authOptions, urlOptions }: NetworkOptions) =>
  new RelayNetworkLayer([
    urlMiddleware({
      credentials: "include",
      ...urlOptions,
    }),
    authMiddleware({
      ...authOptions,
    }),
    persistedQueries({ useGETForHashedQueries: true }),
    invalidGatewayToken(),
  ]);
